export default __webpack_public_path__ + "garageband.58ed8369.png";